import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { MAX_SCRIPT_BLOCK } from "./constants";
import { createVarint } from "./varint";
export function getTrustedInputRaw(transport, transactionData, indexLookup) {
  var data;
  var firstRound = false;

  if (typeof indexLookup === "number") {
    firstRound = true;
    var prefix = Buffer.alloc(4);
    prefix.writeUInt32BE(indexLookup, 0);
    data = Buffer.concat([prefix, transactionData], transactionData.length + 4);
  } else {
    data = transactionData;
  }

  return transport.send(0xe0, 0x42, firstRound ? 0x00 : 0x80, 0x00, data).then(function (trustedInput) {
    return trustedInput.slice(0, trustedInput.length - 2).toString("hex");
  });
}
export function getTrustedInput(_x, _x2, _x3) {
  return _getTrustedInput.apply(this, arguments);
}

function _getTrustedInput() {
  _getTrustedInput = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(transport, indexLookup, transaction) {
    var additionals,
        version,
        inputs,
        outputs,
        locktime,
        isDecred,
        isXST,
        processScriptBlocks,
        processWholeScriptBlock,
        processInputs,
        processOutputs,
        data,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            additionals = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : [];
            version = transaction.version, inputs = transaction.inputs, outputs = transaction.outputs, locktime = transaction.locktime;

            if (!(!outputs || !locktime)) {
              _context4.next = 4;
              break;
            }

            throw new Error("getTrustedInput: locktime & outputs is expected");

          case 4:
            isDecred = additionals.includes("decred");
            isXST = additionals.includes("stealthcoin");

            processScriptBlocks =
            /*#__PURE__*/
            function () {
              var _ref = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(script, sequence) {
                var scriptBlocks, offset, blockSize, _i, scriptBlock;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        scriptBlocks = [];
                        offset = 0;

                        while (offset !== script.length) {
                          blockSize = script.length - offset > MAX_SCRIPT_BLOCK ? MAX_SCRIPT_BLOCK : script.length - offset;

                          if (offset + blockSize !== script.length) {
                            scriptBlocks.push(script.slice(offset, offset + blockSize));
                          } else {
                            scriptBlocks.push(Buffer.concat([script.slice(offset, offset + blockSize), sequence]));
                          }

                          offset += blockSize;
                        } // Handle case when no script length: we still want to pass the sequence
                        // relatable: https://github.com/LedgerHQ/ledger-live-desktop/issues/1386


                        if (script.length === 0) {
                          scriptBlocks.push(sequence);
                        }

                        _i = 0;

                      case 5:
                        if (!(_i < scriptBlocks.length)) {
                          _context.next = 12;
                          break;
                        }

                        scriptBlock = scriptBlocks[_i];
                        _context.next = 9;
                        return getTrustedInputRaw(transport, scriptBlock);

                      case 9:
                        _i++;
                        _context.next = 5;
                        break;

                      case 12:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }));

              return function processScriptBlocks(_x4, _x5) {
                return _ref.apply(this, arguments);
              };
            }();

            processWholeScriptBlock = function processWholeScriptBlock(block) {
              return getTrustedInputRaw(transport, block);
            };

            processInputs =
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee2() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, input, isXSTV2, treeField, _data, data, res;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context2.prev = 3;
                        _iterator = inputs[Symbol.iterator]();

                      case 5:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                          _context2.next = 17;
                          break;
                        }

                        input = _step.value;
                        isXSTV2 = isXST && Buffer.compare(version, Buffer.from([0x02, 0x00, 0x00, 0x00])) === 0;
                        treeField = isDecred ? input.tree || Buffer.from([0x00]) : Buffer.alloc(0);
                        _data = Buffer.concat([input.prevout, treeField, isXSTV2 ? Buffer.from([0x00]) : createVarint(input.script.length)]);
                        _context2.next = 12;
                        return getTrustedInputRaw(transport, _data);

                      case 12:
                        _context2.next = 14;
                        return isDecred ? processWholeScriptBlock(Buffer.concat([input.script, input.sequence])) : isXSTV2 ? processWholeScriptBlock(input.sequence) : processScriptBlocks(input.script, input.sequence);

                      case 14:
                        _iteratorNormalCompletion = true;
                        _context2.next = 5;
                        break;

                      case 17:
                        _context2.next = 23;
                        break;

                      case 19:
                        _context2.prev = 19;
                        _context2.t0 = _context2["catch"](3);
                        _didIteratorError = true;
                        _iteratorError = _context2.t0;

                      case 23:
                        _context2.prev = 23;
                        _context2.prev = 24;

                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                          _iterator.return();
                        }

                      case 26:
                        _context2.prev = 26;

                        if (!_didIteratorError) {
                          _context2.next = 29;
                          break;
                        }

                        throw _iteratorError;

                      case 29:
                        return _context2.finish(26);

                      case 30:
                        return _context2.finish(23);

                      case 31:
                        data = createVarint(outputs.length);
                        _context2.next = 34;
                        return getTrustedInputRaw(transport, data);

                      case 34:
                        res = _context2.sent;
                        return _context2.abrupt("return", res);

                      case 36:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, this, [[3, 19, 23, 31], [24,, 26, 30]]);
              }));

              return function processInputs() {
                return _ref2.apply(this, arguments);
              };
            }();

            processOutputs =
            /*#__PURE__*/
            function () {
              var _ref3 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee3() {
                var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, output, _data2, finalData, res;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _iteratorNormalCompletion2 = true;
                        _didIteratorError2 = false;
                        _iteratorError2 = undefined;
                        _context3.prev = 3;
                        _iterator2 = outputs[Symbol.iterator]();

                      case 5:
                        if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                          _context3.next = 14;
                          break;
                        }

                        output = _step2.value;
                        _data2 = output.amount;
                        _data2 = Buffer.concat([_data2, isDecred ? Buffer.from([0x00, 0x00]) : Buffer.alloc(0), //Version script
                        createVarint(output.script.length), output.script]);
                        _context3.next = 11;
                        return getTrustedInputRaw(transport, _data2);

                      case 11:
                        _iteratorNormalCompletion2 = true;
                        _context3.next = 5;
                        break;

                      case 14:
                        _context3.next = 20;
                        break;

                      case 16:
                        _context3.prev = 16;
                        _context3.t0 = _context3["catch"](3);
                        _didIteratorError2 = true;
                        _iteratorError2 = _context3.t0;

                      case 20:
                        _context3.prev = 20;
                        _context3.prev = 21;

                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                          _iterator2.return();
                        }

                      case 23:
                        _context3.prev = 23;

                        if (!_didIteratorError2) {
                          _context3.next = 26;
                          break;
                        }

                        throw _iteratorError2;

                      case 26:
                        return _context3.finish(23);

                      case 27:
                        return _context3.finish(20);

                      case 28:
                        //Add expiry height for decred
                        finalData = isDecred ? Buffer.concat([locktime, Buffer.from([0x00, 0x00, 0x00, 0x00])]) : locktime;
                        _context3.next = 31;
                        return getTrustedInputRaw(transport, finalData);

                      case 31:
                        res = _context3.sent;
                        return _context3.abrupt("return", res);

                      case 33:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, this, [[3, 16, 20, 28], [21,, 23, 27]]);
              }));

              return function processOutputs() {
                return _ref3.apply(this, arguments);
              };
            }();

            data = Buffer.concat([transaction.version, transaction.timestamp || Buffer.alloc(0), createVarint(inputs.length)]);
            return _context4.abrupt("return", getTrustedInputRaw(transport, data, indexLookup).then(processInputs).then(processOutputs));

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));
  return _getTrustedInput.apply(this, arguments);
}